import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import IosPaymentRedirect from "../../components/IosPaymentRedirect";
import { shouldHideSubscriptionPurchase } from "../../utils/platform";

const SubscriptionPurchase = lazy(() => import("./SubscriptionPurchase"));

/**
 * iOS: redirect immediately — SubscriptionPurchase chunk is never loaded.
 * Android / web: full subscription purchase flow.
 */
export default function SubscriptionRouteGate() {
  if (shouldHideSubscriptionPurchase()) {
    return <IosPaymentRedirect />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex min-h-[50vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      }
    >
      <SubscriptionPurchase />
    </Suspense>
  );
}
